<template>
  <div>
    <vs-popup classContent="popup-example" title="Assign" :active.sync="noteAssignModal">
      <div class="modal-content p-4">
        <vs-input placeholder="Notes Title" v-model="title" class="w-full mb-4" />

        <div class="light_blue_holder p-4">
          <strong>Filter by</strong>
          <vs-row class="mb-4">
            <!-- <vs-col vs-lg="6" vs-sm="12" class="p-1">
              <v-select
                multiple
                :reduce="(option) => option.id"
                @input="fetchCourseList"
                v-model="filterPayload.subject_id"
                label="subject_name"
                class="bg_white w-full"
                placeholder="Filter Subject"
                :options="subjectlist"
                :clearable="false"
                @open="onOpenSubject"
                @close="onCloseSubject"
              >
                <template #list-footer>
                  <li
                    ref="loadSubject"
                    class="loader"
                    v-show="subjectMeta.has_next"
                  >
                    Loading more subjects...
                  </li>
                </template></v-select
              >
            </vs-col> -->
            <vs-col vs-lg="12" vs-sm="12" class="p-1">
              <v-select class="bg_white w-full" placeholder="Course" v-model="filterPayload.course_id" @input="chngData"
                :options="courseList" :reduce="(course) => course.id" label="name" @open="onOpenCourse"
                @close="onCloseCourse">
                <template #list-footer>
                  <li ref="loadCourse" class="loader" v-show="course_list_meta.has_next">
                    Loading more courses...
                  </li>
                </template>
              </v-select>
            </vs-col>
          </vs-row>


          <template>
            <div class="flex flex-wrap justify-between items-center mb-4">
              <div class="md:w-1/3 w-full my-2">
                <div class="px-2">
                  <vs-checkbox class="mb-2" v-model="studentCheck">Students</vs-checkbox>
                </div>
              </div>


              <div class="md:w-1/3 w-full my-2">
                <div class="px-2">
                  <vs-checkbox class="mb-2" v-model="parentCheck">Parents</vs-checkbox>
                </div>
              </div>
              <div class="md:w-1/3 w-full my-2">
                <div class="px-2">
                  <vs-checkbox class="mb-2" v-model="staffCheck">Staffs</vs-checkbox>

                </div>
              </div>
            </div>
            <div class="inline-flex w-full py-2" v-if="studentCheck">
              <label style="min-width: 100px">Students</label>
              <v-select :getOptionLabel="
                (item) => `${item.first_name} ${item.last_name}`
              " class="bg_white w-full" placeholder="Students" v-model="selectedStudent" :options="studentlist"
                label="name" @open="onOpenStudent" @close="onCloseStudent" multiple>
                <template v-slot:selected-option="studentlist">
                  <img v-if="studentlist.picture" class="person-img rounded-full" :src="studentlist.picture" />
                  <img v-else class="person-img rounded-full" src="@/assets/images/pages/user-circle-solid.svg" />
                  {{ studentlist.first_name }}
                  {{ studentlist.last_name }}
                </template>
                <template v-slot:option="studentlist">
                  <img v-if="studentlist.picture" class="person-img rounded-full" :src="studentlist.picture" />
                  <img v-else class="person-img rounded-full" src="@/assets/images/pages/user-circle-solid.svg" />
                  {{ studentlist.first_name }}
                  {{ studentlist.last_name }}
                </template>
                <template #list-footer>
                  <li ref="loadStudent" class="loader" v-show="student_meta.has_next">
                    Loading more students...
                  </li>
                </template>
              </v-select>
            </div>
            <div class="inline-flex w-full py-2" v-if="parentCheck">
              <label style="min-width: 100px">Parents</label>
              <v-select :getOptionLabel="
                (item) => `${item.first_name} ${item.last_name}`
              " class="bg_white w-full" placeholder="Parents" v-model="selectedParent" :options="parentlist"
                label="name" @open="onOpenParent" @close="onCloseParent" multiple>
                <template v-slot:selected-option="parentlist">
                  <img v-if="parentlist.picture" class="person-img rounded-full" :src="parentlist.picture" />
                  <img v-else class="person-img rounded-full" src="@/assets/images/pages/user-circle-solid.svg" />
                  {{ parentlist.first_name }}
                  {{ parentlist.last_name }}
                </template>
                <template v-slot:option="parentlist">
                  <img v-if="parentlist.picture" class="person-img rounded-full" :src="parentlist.picture" />
                  <img v-else class="person-img rounded-full" src="@/assets/images/pages/user-circle-solid.svg" />
                  {{ parentlist.first_name }}
                  {{ parentlist.last_name }}
                </template>
                <template #list-footer>
                  <li ref="loadParent" class="loader" v-show="parent_meta.has_next">
                    Loading more parents...
                  </li>
                </template>
              </v-select>
            </div>
            <div class="inline-flex w-full py-2" v-if="staffCheck">
              <label style="min-width: 100px">Staffs</label>
              <v-select :getOptionLabel="
                (item) => `${item.first_name} ${item.last_name}`
              " class="bg_white w-full" placeholder="Staffs" v-model="selectedStaff" :options="teacherList"
                label="name" @open="onOpenTeacher" @close="onCloseTeacher" multiple>
                <template v-slot:selected-option="teacherList">
                  <img v-if="teacherList.picture" class="person-img rounded-full" :src="teacherList.picture" />
                  <img v-else class="person-img rounded-full" src="@/assets/images/pages/user-circle-solid.svg" />
                  {{ teacherList.first_name }}
                  {{ teacherList.last_name }}
                </template>
                <template v-slot:option="teacherList">
                  <img v-if="teacherList.picture" class="person-img rounded-full" :src="teacherList.picture" />
                  <img v-else class="person-img rounded-full" src="@/assets/images/pages/user-circle-solid.svg" />
                  {{ teacherList.first_name }}
                  {{ teacherList.last_name }}
                </template>
                <template #list-footer>
                  <li ref="loadTeacher" class="loader" v-show="teacher_meta.has_next">
                    Loading more staffs...
                  </li>
                </template>
              </v-select>
            </div>
          </template>

        </div>


        <vs-divider />

        <vs-button class="block mx-auto" @click="assignToNote">Proceed</vs-button>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import { list_subject } from '@/api/subject'
import { shortCourseList } from '@/api/admission'
import { fetchUserClient } from '@/api/task-project.js'
import { assignToNote } from '@/api/lesson_notes.js'

export default {
  props: {
    noteAssignModal: {
      default: false
    },
    note_id: {
      default: null
    }
  },
  components: {
    vSelect
  },
  watch: {
    studentCheck () {
      if (this.studentCheck) this.fetchStudentList()
    },
    parentCheck () {
      if (this.parentCheck) this.fetchParentList()
    },
    staffCheck () {
      if (this.staffCheck) this.getTeacherList()
    },
    noteAssignModal () {
      if (!this.noteAssignModal) {
        this.$emit('closeAssignmentModal', false)
      }
    }
  },
  mounted () {
    // this.fetchSubjectList()
    this.fetchCourseList()
  },
  data () {
    return {
      selectedStudent: [],
      selectedParent: [],
      selectedStaff: [],
      customer_id: localStorage.getItem('customer_id'),
      studentlist: [],
      parentlist: [],
      staffList: [],
      subjectMeta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      course_list_meta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      filterPayload: {
        course_id: null,
        subject_id: []
      },
      student_meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      parent_meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      teacher_meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      subjectlist: [],
      courseList: [],
      teacherList: [],
      observerSubject: new IntersectionObserver(this.loadMoreSubjects),
      observerCourse: new IntersectionObserver(this.loadMoreCourses),
      observerStudent: new IntersectionObserver(this.loadMorestudents),
      observerParents: new IntersectionObserver(this.loadMoreParent),
      observerTeacher: new IntersectionObserver(this.loadMoreStaff),
      studentCheck: false,
      parentCheck: false,
      staffCheck: false,
      studentDropdown: false,
      parentDropdown: false,
      staffDropdown: false,
      title: ''
    }
  },
  methods: {
    chngData () {
      this.fetchStudentList()
      this.fetchParentList()
      this.getTeacherList()
    },
    async onOpenParent () {
      if (this.parent_meta.has_next) {
        await this.$nextTick()
        this.observerParents.observe(this.$refs.loadParent)
      }
    },
    onCloseParent () {
      this.observerParents.disconnect()
    },
    async onOpenTeacher () {
      if (this.teacher_meta.has_next) {
        await this.$nextTick()
        this.observerTeacher.observe(this.$refs.loadTeacher)
      }
    },
    onCloseTeacher () {
      this.observerTeacher.disconnect()
    },
    async onOpenStudent () {
      if (this.student_meta.has_next) {
        await this.$nextTick()
        this.observerStudent.observe(this.$refs.loadStudent)
      }
    },
    onCloseStudent () {
      this.observerStudent.disconnect()
    },
    async assignToNote () {
      // 1-->teachers, 2->parent, 3->student
      const Studentreceivers = this.selectedStudent.map((ele) => {
        return {
          receiver_id: ele.client_users_id,
          receiver_type: 3
        }
      })
      const parentreceivers = this.selectedParent.map((ele) => {
        return {
          receiver_id: ele.client_users_id,
          receiver_type: 2
        }
      })
      const Staffreceivers = this.selectedStaff.map((ele) => {
        return {
          receiver_id: ele.users_id,
          receiver_type: 1
        }
      })

      const payload = {
        title: this.title,
        receivers: [...Studentreceivers, ...Staffreceivers, ...parentreceivers]
      }
      await assignToNote(this.customer_id, this.note_id, payload)

      this.$emit('closeAssignmentModal', false)
      this.showSuccessMessage(
        'Success',
        'Note assigned successfully',
        'success'
      )
    },
    checkStudent (user_id) {
      const check = this.selectedStudent.findIndex(
        (ele) => ele.client_users_id === user_id
      )
      if (check === -1) {
        return false
      } else {
        return true
      }
    },
    checkParent (user_id) {
      const check = this.selectedParent.findIndex(
        (ele) => ele.client_users_id === user_id
      )
      if (check === -1) {
        return false
      } else {
        return true
      }
    },
    checkStaff (user_id) {
      const check = this.selectedStaff.findIndex(
        (ele) => ele.users_id === user_id
      )
      if (check === -1) {
        return false
      } else {
        return true
      }
    },
    async addToSelectStudent (student) {
      const check = this.selectedStudent.findIndex(
        (ele) => ele.client_users_id === student.client_users_id
      )
      if (check === -1) {
        this.selectedStudent.push(student)
      } else {
        this.selectedStudent = this.selectedStudent.filter(
          (ele) => ele.client_users_id !== student.client_users_id
        )
      }
    },
    async addToSelectAllStudent () {
      if (this.selectedStudent.length === this.studentlist.length) {
        this.selectedStudent = []
      } else {
        this.selectedStudent = this.studentlist
      }
    },
    async addToSelectAllParent () {
      if (this.selectedParent.length === this.parentlist.length) {
        this.selectedParent = []
      } else {
        this.selectedParent = this.parentlist
      }
    },
    async addToSelectAllTeacher () {
      if (this.selectedStaff.length === this.teacherList.length) {
        this.selectedStaff = []
      } else {
        this.selectedStaff = this.teacherList
      }
    },
    async addToSelectParent (parent) {
      const check = this.selectedParent.findIndex(
        (ele) => ele.client_users_id === parent.client_users_id
      )
      if (check === -1) {
        this.selectedParent.push(parent)
      } else {
        this.selectedParent = this.selectedParent.filter(
          (ele) => ele.client_users_id !== parent.client_users_id
        )
      }
    },
    async addToSelectStaff (staff) {
      const check = this.selectedStaff.findIndex(
        (ele) => ele.users_id === staff.users_id
      )
      if (check === -1) {
        this.selectedStaff.push(staff)
      } else {
        this.selectedStaff = this.selectedStaff.filter(
          (ele) => ele.users_id !== staff.users_id
        )
      }
    },
    async removeStudent (index) {
      this.selectedStudent.splice(index, 1)
    },
    async removeParent (index) {
      this.selectedParent.splice(index, 1)
    },
    async removeStaff (index) {
      this.selectedStaff.splice(index, 1)
    },
    async detectsStudentScrollLength () {
      if (
        Math.ceil(
          this.$refs.element.scrollTop + this.$refs.element.offsetHeight
        ) >= this.$refs.element.scrollHeight
      ) {
        this.loadMorestudents()
      }
    },
    async detectsParentScrollLength () {
      if (
        Math.ceil(
          this.$refs.elementParent.scrollTop +
          this.$refs.elementParent.offsetHeight
        ) >= this.$refs.elementParent.scrollHeight &&
        this.parent_meta.has_next
      ) {
        this.loadMoreParent()
      }
    },
    async detectsStaffScrollLength () {
      if (
        Math.ceil(
          this.$refs.elementStaff.scrollTop +
          this.$refs.elementStaff.offsetHeight
        ) >= this.$refs.elementStaff.scrollHeight
      ) {
        this.loadMoreStaff()
      }
    },
    async loadMoreParent () {
      try {
        const payload = {
          ...this.filterPayload,
          type: ['parent']
        }
        this.parent_meta.page = this.parent_meta.page + 1

        const data = await fetchUserClient(
          'Client',
          this.customer_id,
          this.parent_meta,
          payload
        )
        this.parentlist.push(...data.data.data.users_list)
        this.parent_meta = data.data.data.meta
        this.parent_meta.page = data.data.data.meta.current_page
      } catch (e) {
        //
      }
    },
    async loadMoreStaff () {
      try {
        const payload = {
          ...this.filterPayload
        }
        this.teacher_meta.page = this.teacher_meta.page + 1

        const data = await fetchUserClient(
          'User',
          this.customer_id,
          this.teacher_meta,
          payload
        )
        this.teacherList.push(...data.data.data.users_list)
        this.teacher_meta = data.data.data.meta
        this.teacher_meta.page = data.data.data.meta.current_page
      } catch (e) {
        //
      }
    },
    async loadMorestudents () {
      try {
        const payload = {
          ...this.filterPayload,
          type: ['children', 'individual']
        }
        this.student_meta.page = this.student_meta.page + 1

        const data = await fetchUserClient(
          'Client',
          this.customer_id,
          this.student_meta,
          payload
        )
        this.studentlist.push(...data.data.data.users_list)
        this.student_meta = data.data.data.meta
        this.student_meta.page = data.data.data.meta.current_page
      } catch (e) {
        //
      }
    },
    async getTeacherList () {
      try {
        const payload = {
          ...this.filterPayload
        }

        const { data } = await fetchUserClient(
          'User',
          this.customer_id,
          this.teacher_meta,
          payload
        )
        this.teacherList = data.data.users_list
        this.teacher_meta = data.data.meta
        this.teacher_meta.page = data.data.meta.current_page
      } catch (e) {
        console.log(e)
      }
    },
    async fetchStudentList () {
      try {
        const payload = {
          ...this.filterPayload,
          type: ['children', 'individual']
        }
        const data = await fetchUserClient(
          'Client',
          this.customer_id,
          this.student_meta,
          payload
        )
        this.studentlist = data.data.data.users_list
        this.student_meta = data.data.data.meta
        this.student_meta.page = data.data.data.meta.current_page
      } catch (e) {
        console.log(e)
      }
    },
    async fetchParentList () {
      try {
        const payload = {
          ...this.filterPayload,
          type: ['parent']
        }
        const data = await fetchUserClient(
          'Client',
          this.customer_id,
          this.parent_meta,
          payload
        )
        this.parentlist = data.data.data.users_list
        this.parent_meta = data.data.data.meta
        this.parent_meta.page = data.data.data.meta.current_page
      } catch (e) {
        console.log(e)
      }
    },
    async onOpenCourse () {
      if (this.course_list_meta.has_next) {
        await this.$nextTick()
        this.observerCourse.observe(this.$refs.loadCourse)
      }
    },
    onCloseCourse () {
      this.observerCourse.disconnect()
    },
    async loadMoreCourses () {
      try {
        const payload = {
          // subject_id: this.filterPayload.subject_id
        }
        this.course_list_meta.current_page =
          this.course_list_meta.current_page + 1
        const { data } = await shortCourseList(
          localStorage.getItem('customer_id'),
          payload,
          this.course_list_meta
        )
        this.courseList.push(...data.data.course_list)
        this.course_list_meta = data.data.meta
      } catch (e) {
        console.log(e)
      }
    },
    async loadMoreSubjects () {
      try {
        this.subjectMeta.current_page = this.subjectMeta.current_page + 1
        const { data } = await list_subject(
          localStorage.getItem('customer_id'),
          this.subjectMeta.current_page
        )
        this.subjectlist.push(...data.data.subjectlist)
        this.subjectMeta = data.data.meta
      } catch (e) {
        console.log(e)
      }
    },
    async onOpenSubject () {
      if (this.subjectMeta.has_next) {
        await this.$nextTick()
        this.observerSubject.observe(this.$refs.loadSubject)
      }
    },
    onCloseSubject () {
      this.observerSubject.disconnect()
    },
    async fetchSubjectList () {
      const customerId = this.$store.getters.customerId

      try {
        const { data } = await list_subject(customerId, 1)
        this.subjectlist = data.data.subjectlist
        this.subjectMeta = data.data.meta
      } catch (e) {
        console.log(e)
      }
    },
    async fetchCourseList () {
      try {
        const payload = {
          // subject_id: this.filterPayload.subject_id
        }
        this.course_list_meta.current_page = 1
        const { data } = await shortCourseList(
          localStorage.getItem('customer_id'),
          payload,
          this.course_list_meta
        )
        this.courseList = data.data.course_list

        this.course_list_meta = data.data.meta

        this.fetchStudentList()
        this.fetchParentList()
        this.getTeacherList()
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
